module.exports = __webpack_public_path__ + "static/media/NotoSans-Regular.2c157a50.ttf";